import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import { Navigate, useLocation } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../constants";
import TamperingIssues from "../diff/issuesDiff/threatHunting/TamperingIssues";
import { useReportRootPath } from "../hooks";
import { useReproducibilityContext } from "./Reproducibility";
const ReproIssuesTab = () => {
    const { issues, hasIssues } = useReproducibilityContext();
    const reportRootPath = useReportRootPath();
    const { search } = useLocation();
    if (!hasIssues)
        return (React.createElement(Navigate, { to: {
                pathname: `${reportRootPath}/${REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE}/${REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES}`,
                search,
            }, replace: true }));
    return (React.createElement(ErrorBoundary, { key: "tampering-issues" },
        React.createElement(TamperingIssues, { issues: issues, idPrefix: "repro-issues" })));
};
export default ReproIssuesTab;
//# sourceMappingURL=ReproIssuesTab.js.map